document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
            var tabClass = tab.dataset.id;

            tab.classList.add('active');
            [...tab.parentElement.children].forEach(function (sibling) {
                if (sibling !== tab) sibling.classList.remove('active');
            });

            document.querySelectorAll('.tab-content').forEach(function (content, i) {
                content.classList.remove('active');
                content.classList.add('inactive', 'tab-content-' + (i + 1));
            });

            document.querySelectorAll('.tab-content-' + tabClass).forEach(function (content) {
                content.classList.remove('inactive');
                content.classList.add('active');
            });
        });
    });

    // Aktivera tab baserat på URL-hash, t.ex. #corner-hotel
    var hash = window.location.hash.slice(1);
    if (hash) {
        var target = document.querySelector('.tab[id="' + hash + '"]');
        if (target) {
            target.click();
            target.blur();
        }
    }
});

//# sourceMappingURL=tabs.js.map
